import HomePage from "./Home";
import ProductList from "./Product/List";
import ProductDetail from "./Product/Detail";
import Checkout from "./Checkout";
import PaymentResult from "./Checkout/result";
import NotFound from "./404";

const Layout = {
    HomePage,
    ProductList,
    ProductDetail,
    Checkout,
    PaymentResult,
    NotFound
};

export default Layout;